import { X, Trash2, Ban } from "lucide-react";

/**
 * Reusable floating action bar shown when >=1 row is selected in an admin table.
 *
 * Props:
 *  - count            : number  · selected count
 *  - onCancel         : func    · clears the selection (always shown)
 *  - onDelete         : func    · bulk-delete (shown unless hideDelete)
 *  - onCancelOrders   : func    · optional — extra "Cancel orders" action (Orders tab only)
 *  - itemName         : string  · e.g. "product" / "order"
 *  - hideDelete       : bool    · hide the destructive Delete button
 */
export default function BulkActions({ count, onCancel, onDelete, onCancelOrders, itemName = "item", hideDelete = false }) {
  if (count === 0) return null;
  return (
    <div
      className="sticky top-2 z-20 mx-2 mb-3 flex flex-wrap items-center gap-3 rounded-2xl border border-deepbrown/10 bg-white px-4 py-3 shadow-md"
      data-testid="bulk-actions-bar"
    >
      <span className="text-sm font-bold text-deepbrown" data-testid="bulk-actions-count">
        {count} {itemName}{count === 1 ? "" : "s"} selected
      </span>
      <div className="flex flex-1 items-center justify-end gap-2">
        {onCancelOrders && (
          <button
            onClick={onCancelOrders}
            className="inline-flex items-center gap-1.5 rounded-full bg-marigold/20 px-3 py-1.5 text-xs font-bold text-deepbrown hover:bg-marigold/40"
            data-testid="bulk-cancel-orders-btn"
          >
            <Ban className="h-3 w-3" /> Cancel orders
          </button>
        )}
        <button
          onClick={onCancel}
          className="inline-flex items-center gap-1.5 rounded-full bg-deepbrown/10 px-3 py-1.5 text-xs font-bold text-deepbrown hover:bg-deepbrown/20"
          data-testid="bulk-cancel-btn"
        >
          <X className="h-3 w-3" /> Cancel
        </button>
        {!hideDelete && (
          <button
            onClick={onDelete}
            className="inline-flex items-center gap-1.5 rounded-full bg-rani px-3 py-1.5 text-xs font-bold text-white hover:bg-rani/90"
            data-testid="bulk-delete-btn"
          >
            <Trash2 className="h-3 w-3" /> Delete selected
          </button>
        )}
      </div>
    </div>
  );
}
